"use strict";

var LoggerInstance = require("js-logger").get("InputHelper");

var HtmlHelper = require("./HtmlHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var Constants = require("../designer/Constants");

// InputHelper
module.exports = {
	formatDate: function(date, startingFormat, wizardDateFormat) {
		date = (date || "").trim();
		//moment.js recommends against doing this, but it works very well now, until the deprecated feature is removed.
		//	I used to have this: var momentDate = window.moment(date, startingFormat || wizardDateFormat);
		var momentDate = window.moment(date);
		if (momentDate.isValid()) {
			return momentDate.format(wizardDateFormat);
		}
		return date;
	},

	parseAndFormatDate: function (dateString) {
		var apiDateFormat = "YYYY-MM-DD";
		var date = moment(dateString, apiDateFormat);

		//Moment essentially converts something like "010121" in "01/01/10121" so making sure the year range is valid for dates
		if (!date.isValid() || date.year() < 1753 || date.year() > 9999) {
			return null;
		}

		return date && date.format(apiDateFormat);
	},

	/* 	allowDecimals: are decimals allowed (default: true, optional)
		greaterThanZero: do values have to be greater than zero (default: false, optional)
		formatAmount: should the amount formatted with currency symbol and grouping separators (default: true, optional))
		defaultValue: the default amount if the amount is invalid (optional, if not provided, it will just set it to the last valid value or it will stay blank.
		includeThousandsSeparator: should the amount be formatted to include a thousands separator (default: true, optional)
		allowNegative: should the amount be allowed to be negative (default: false, optional)
	*/
	initializeAmountInput: function($component, amountSelector, allowDecimals, greaterThanZero, formatAmount, defaultValue, includeThousandsSeparator, allowNegative) {
		if (!$component || !$component.length) {
			return;
		}

		var $donationAmountInputs = $component;
		if (!$component.is(amountSelector)) {
			$donationAmountInputs = $component.find(amountSelector);
		}

		if (!$donationAmountInputs || !$donationAmountInputs.length) {
			return;
		}

		if (allowDecimals == null) { //coercion: undefined == null is true is true as well
			//Defaulting to true
			allowDecimals = true;
		}

		if (formatAmount == null) { //coercion: undefined == null is true is true as well
			//Defaulting to true
			formatAmount = true;
		}

		if (formatAmount) {
			$donationAmountInputs.blur((event) => {
				var $target = $(event.currentTarget);
				var value = event.currentTarget.value || "";

				var amount = ActionsHelper.convertFormattedAmountToNumber(value) || "";
				$target.val(ActionsHelper.formatAmount(amount, $target, /*keepDecimals*/true, includeThousandsSeparator));
			});
		} else if (defaultValue) {
			$donationAmountInputs.blur((event) => {
				if (!event.currentTarget.value) {
					$(event.currentTarget).val(defaultValue);
				}
			});
		}

		$donationAmountInputs.focus((event) => {
			var target = event.currentTarget;
			var selectAll;
			if (target.selectionStart === 0 && target.selectionEnd === (target.value || "").length) {
				//This probably means we tabbed into it, or at least it is all selected.
				selectAll = true;
			}
			var value = target.value || "";
			value = ActionsHelper.convertFormattedAmountToNumberString(value, /*useCurrencyFormatDecimalSeparator*/true) || "";
			$(target).val(value);
			target.oldValue = value;
			if (selectAll) {
				//If we tabbed into the field, we should highlighting all the amount text (we have to do this because we changed the value)
				event.currentTarget.setSelectionRange(0, value.length);
			}
		});

		$donationAmountInputs.change((event) => {
			this._validateAmount(event, allowDecimals, greaterThanZero, defaultValue, allowNegative);
		});

		$donationAmountInputs.keyup((event) => {
			this._validateAmount(event, allowDecimals, greaterThanZero, defaultValue, allowNegative);
		});

		$donationAmountInputs.keydown((event) => {
			if (event.ctrlKey || event.metaKey || event.altKey) {
				return true;
			}

			//Getting the character code of the decimal character
			var decimalCharacterCode;
			var numberPadDecimalCharacterCode;
			if (window.currencyFormat.decimalSeparator === ".") {
				decimalCharacterCode = Constants.KEYS.DECIMAL;
				numberPadDecimalCharacterCode = Constants.KEYS.NUM_PAD_DECIMAL;
			}

			switch (event.which) {
				case Constants.KEYS.DELETE:
				case Constants.KEYS.BACKSPACE:
				case Constants.KEYS.ARROW_UP:
				case Constants.KEYS.ARROW_RIGHT:
				case Constants.KEYS.ARROW_DOWN:
				case Constants.KEYS.ARROW_LEFT:
				case Constants.KEYS.TAB:
				case Constants.KEYS.ESCAPE:
				case Constants.KEYS.HOME:
				case Constants.KEYS.END:
				case Constants.KEYS.PAGE_UP:
				case Constants.KEYS.PAGE_DOWN:
					//event not handled, allowing the key down, as this is not a printable character
					return true;
				default:
					//Top Numbers and Numpad numbers
					if ((decimalCharacterCode && event.which === decimalCharacterCode) ||
						(numberPadDecimalCharacterCode && event.which === numberPadDecimalCharacterCode) ||
						(window.currencyFormat.decimalSeparator && window.currencyFormat.decimalSeparator === event.key)) {
						//We entered the decimal separator character
						return allowDecimals;
					}
					//Negative symbol
					if (event.which === Constants.KEYS.MINUS || event.which === Constants.KEYS.NUM_PAD_MINUS) {
						return allowNegative;
					}
					if ((event.which >= 48 && event.which <= 57) || (event.which >= 96 && event.which <= 105)) {
						return true;
					}
					//Do not allow
					return false;
			}
		});

		if (defaultValue) {
			$donationAmountInputs.each((index, element) => {
				this._validateAmount({currentTarget: element}, allowDecimals, greaterThanZero, defaultValue, allowNegative);
			});
		}
	},

	/* 
	greaterThanZero: do values have to be greater than zero (default: false, optional)
	formatDecimal: should the decimal be formatted with grouping separators (default: true, optional))
	defaultValue: the default amount if the amount is invalid (optional, if not provided, it will just set it to the last valid value or it will stay blank.
	includeThousandsSeparator: should the amount be formatted to include a thousands separator (default: true, optional)
	allowNegative: should the amount be allowed to be negative (default: false, optional)
	*/
	initializeDecimalInput: function ($component, decimalSelector, greaterThanZero, formatDecimal, defaultValue, includeThousandsSeparator, allowNegative) {
		if (!$component || !$component.length) {
			return;
		}

		var $decimalInputs = $component;
		if (!$component.is(decimalSelector)) {
			$decimalInputs = $component.find(decimalSelector);
		}

		if (!$decimalInputs || !$decimalInputs.length) {
			return;
		}

		if (formatDecimal == null) { //coercion: undefined == null is true is true as well
			//Defaulting to true
			formatDecimal = true;
		}

		if (formatDecimal) {
			$decimalInputs.blur((event) => {
				var $target = $(event.currentTarget);
				var value = event.currentTarget.value || "";

				var amount = ActionsHelper.convertFormattedAmountToNumber(value) || "";
				$target.val(ActionsHelper.formatDecimal(amount, $target, includeThousandsSeparator));
			});
		} else if (defaultValue) {
			$decimalInputs.blur((event) => {
				if (!event.currentTarget.value) {
					$(event.currentTarget).val(defaultValue);
				}
			});
		}

		$decimalInputs.focus((event) => {
			var target = event.currentTarget;
			var selectAll;
			if (target.selectionStart === 0 && target.selectionEnd === (target.value || "").length) {
				//This probably means we tabbed into it, or at least it is all selected.
				selectAll = true;
			}
			var value = target.value || "";
			value = ActionsHelper.convertFormattedAmountToNumberString(value, /*useCurrencyFormatDecimalSeparator*/true) || "";
			$(target).val(value);
			target.oldValue = value;
			if (selectAll) {
				//If we tabbed into the field, we should highlighting all the amount text (we have to do this because we changed the value)
				event.currentTarget.setSelectionRange(0, value.length);
			}
		});

		$decimalInputs.change((event) => {
			this._validateDecimal(event, greaterThanZero, defaultValue, allowNegative);
		});

		$decimalInputs.keyup((event) => {
			this._validateDecimal(event, greaterThanZero, defaultValue, allowNegative);
		});

		$decimalInputs.keydown((event) => {
			if (event.ctrlKey || event.metaKey || event.altKey) {
				return true;
			}

			//Getting the character code of the decimal character
			var decimalCharacterCode;
			var numberPadDecimalCharacterCode;
			if (window.currencyFormat.decimalSeparator === ".") {
				decimalCharacterCode = Constants.KEYS.DECIMAL;
				numberPadDecimalCharacterCode = Constants.KEYS.NUM_PAD_DECIMAL;
			}

			switch (event.which) {
				case Constants.KEYS.DELETE:
				case Constants.KEYS.BACKSPACE:
				case Constants.KEYS.ARROW_UP:
				case Constants.KEYS.ARROW_RIGHT:
				case Constants.KEYS.ARROW_DOWN:
				case Constants.KEYS.ARROW_LEFT:
				case Constants.KEYS.TAB:
				case Constants.KEYS.ESCAPE:
				case Constants.KEYS.HOME:
				case Constants.KEYS.END:
				case Constants.KEYS.PAGE_UP:
				case Constants.KEYS.PAGE_DOWN:
					//event not handled, allowing the key down, as this is not a printable character
					return true;
				default:
					//Top Numbers and Numpad numbers
					if ((decimalCharacterCode && event.which === decimalCharacterCode) ||
						(numberPadDecimalCharacterCode && event.which === numberPadDecimalCharacterCode) ||
						(window.currencyFormat.decimalSeparator && window.currencyFormat.decimalSeparator === event.key)) {
						//We entered the decimal separator character
						return true;
					}
					//Negative symbol
					if (event.which === Constants.KEYS.MINUS || event.which === Constants.KEYS.NUM_PAD_MINUS) {
						return allowNegative;
					}
					if ((event.which >= 48 && event.which <= 57) || (event.which >= 96 && event.which <= 105)) {
						return true;
					}
					//Do not allow
					return false;
			}
		});

		if (defaultValue) {
			$decimalInputs.each((index, element) => {
				this._validateDecimal({ currentTarget: element }, greaterThanZero, defaultValue, allowNegative);
			});
		}
	},

	initializeDates: function(options) {
		options = options || {};
		var $component = options.$component;
		var dateSelector = options.dateSelector;
		var startingFormat = options.startingFormat;
		var wizardDateFormat = options.wizardDateFormat;

		if (!$component || !$component.length) {
			return;
		}

		var $dateInputs = $component;
		if (!$component.is(dateSelector)) {
			$dateInputs = $component.find(dateSelector);
		}

		if (!$dateInputs || !$dateInputs.length) {
			return;
		}

		$dateInputs.blur((event) => {
			var value = event.currentTarget.value;
			event.currentTarget.value = this.formatDate(value, startingFormat || wizardDateFormat, wizardDateFormat);
		});
	},

	initializeIntegerInput: function(options) {
		options = options || {};
		var $component = options.$component;
		var defaultValue = options.defaultValue;
		var greaterThanZero = options.greaterThanZero;
		var numberSelector = options.numberSelector;
		var allowNegative = options.allowNegative;
		this.initializeAmountInput($component, numberSelector, /*allowDecimals*/false, greaterThanZero, /*formatAmount*/false, defaultValue, /*includeThousandsSeparator*/false, allowNegative);
	},

	isAmountValid: function(amount, allowNegative) {
		if (amount == null) { // coercion, I want null and undefined to match but not 0
			return false;
		}

		var escapedDecimalSeparator = ActionsHelper.escapeRegExp(window.currencyFormat.decimalSeparator);
		var digitWithDecimalSeparator = `^\\d*${escapedDecimalSeparator}\\d{1,2}$|^\\d*$|^\\d*${escapedDecimalSeparator}$|^${escapedDecimalSeparator}\\d{1,2}$|^${escapedDecimalSeparator}\\d{1,2}$|^${escapedDecimalSeparator}$`;
		var digitWithDecimalSeparatorRegex = new RegExp(digitWithDecimalSeparator, "g");

		if (allowNegative) {
			// This regex allows negative numbers, but only if the negative sign is at the beginning of the string.
			digitWithDecimalSeparatorRegex = new RegExp(`${digitWithDecimalSeparator}|^\\-\\d*${escapedDecimalSeparator}\\d{1,2}$|^\\-\\d*$|^\\-\\d*${escapedDecimalSeparator}$|^\\-${escapedDecimalSeparator}\\d{1,2}$|^\\-${escapedDecimalSeparator}\\d{1,2}$|^\\-${escapedDecimalSeparator}$`, "g");
		}

		return amount.match(digitWithDecimalSeparatorRegex);
	},

	isDecimalValid: function (amount, allowNegative) {
		if (amount == null) { // coercion, I want null and undefined to match but not 0
			return false;
		}

		var escapedDecimalSeparator = ActionsHelper.escapeRegExp(window.currencyFormat.decimalSeparator);
		var digitWithDecimalSeparator = `^\\d*${escapedDecimalSeparator}\\d{1,}$|^\\d*$|^\\d*${escapedDecimalSeparator}$|^${escapedDecimalSeparator}\\d{1,}$|^${escapedDecimalSeparator}\\d{1,}$|^${escapedDecimalSeparator}$`;
		var digitWithDecimalSeparatorRegex = new RegExp(digitWithDecimalSeparator, "g");

		if (allowNegative) {
			// This regex allows negative numbers, but only if the negative sign is at the beginning of the string.
			digitWithDecimalSeparatorRegex = new RegExp(`${digitWithDecimalSeparator}|^\\-\\d*${escapedDecimalSeparator}\\d{1,}$|^\\-\\d*$|^\\-\\d*${escapedDecimalSeparator}$|^\\-${escapedDecimalSeparator}\\d{1,}$|^\\-${escapedDecimalSeparator}\\d{1,}$|^\\-${escapedDecimalSeparator}$`, "g");
		}

		return amount.match(digitWithDecimalSeparatorRegex);
	},

	//Helps make sure the for attribute is correct on the label
	prepareCheckboxAndLabel: function($parentNode, checkboxComponentName, scopeSelector) {
		$parentNode = ($parentNode || $("body"));
		var $checkboxComponents = $parentNode.find(`[data-component="${checkboxComponentName}"][data-checkbox]`);

		$checkboxComponents.each((index, element) => {
			var $singleCheckbox = $(element);
			var checkboxUniqueIdentifier = $singleCheckbox.attr("data-checkbox");

			//Trying to fix issue with repeater when loading the page for the constituent by limiting to a specific scope
			var $scopeParent = scopeSelector ? $singleCheckbox.closest(scopeSelector) : $parentNode;
			if (!$scopeParent.length) {
				$scopeParent = $parentNode;
			}

			var $labelComponent = $scopeParent.find(`[data-checkbox-label="${checkboxUniqueIdentifier}"]`);

			var checkboxId = $singleCheckbox.attr("id");
			if (!checkboxId) {
				checkboxId = HtmlHelper.getId($("body"));
				$singleCheckbox.attr("id", checkboxId);
			}

			$labelComponent.attr("for", checkboxId);
		});
	},

	getGeneralInputValues: function($namedInputs) {
		var inputData = []

		$namedInputs.each((index, element) => {
			var $element = $(element);
			var componentName = $element.attr("data-component");
			var $parentComponent,
				data = null;

			if (!componentName.includes(".")) {
				LoggerInstance.debug(`${componentName} is not a valid input`);
				return;
			}

			$parentComponent = $element.parents(`[data-component="${componentName.split(".")[0]}"]`);
			var calculatedTypeCategory = $parentComponent.attr("data-code-type-category");

			switch ($parentComponent.attr("data-component")) {
				case "multipleCheckboxes":
					if ($element.is(":checked")) {
						data = {
							"type": $element.attr("name"),
							"value": $element.val()
						};
					} else {
						data = {
							"isDeleted": true,
							"type": $element.attr("name"),
							"value": $element.val()
						};
					}
					break;

				case "singleCheckbox":
					data = { "type": $element.attr("name") };
					if ($element.is(":checked")) {
						data.value = $parentComponent.attr("code-type-true-value");
					} else {
						data.value = $parentComponent.attr("code-type-false-value");
					}
					break;

				case "select":
					data = {
						"type": $element.attr("name"),
						"value": $element.val()
					};
					break;

				case "radioButtons":
					if ($element.prop("checked")) {
						data = {
							"type": $element.attr("name"),
							"value": $element.val()
						};
					}
					break;

				case "textInput":
				case "textArea":
					data = this.getTextInputData($element, $parentComponent);
					break;
				default:
					LoggerInstance.debug(`${$parentComponent.attr("data-component")} is not supported`);
					break;
			}

			//If we have a valid input
			if (data) {
				//Check to see if there is a category that would be used for a calculated type
				if (calculatedTypeCategory) {
					data.calculatedTypeCategory = calculatedTypeCategory;
				}
				inputData.push(data);
			}
		});

		return inputData;
	},

	getTextInputData: function ($element, $parentComponent) {
		var dataBinding = $parentComponent.attr("data-data-binding");

		if (!dataBinding) {
			return null;
		}

		var dataBindingType = dataBinding.split("-")[0];
		var dataBindingValue = dataBinding.replace("dataBinding-", "")
			.replace("singleValueDate-X06-", "")
			.replace("multiValueDate-X06-", "")
			.replace("note-NOTE-", "")
			.replace("singleValueNumber-X07-", "")
			.replace("multiValueNumber-X07-", "");

		// For data bindings in the general 'dataBinding' property group,
		// the data binding value represents the type of binding.
		if (dataBindingType === "dataBinding") {
			dataBindingType = dataBindingValue;
		}

		switch (dataBindingType) {
			case "shortComment":
				return {
					shortComment: $element.val()
				}
			case "longComment":
				return {
					longComment: $element.val()
				}
			case "singleValueDate":
			case "multiValueDate":
				return {
					type: dataBindingValue,
					value: this.parseAndFormatDate($element.val())
				};
			case "note":
				var isLongComment = $parentComponent.attr("data-note-field") === "long";

				return {
					type: dataBindingValue,
					shortComment: !isLongComment ? $element.val() : null,
					longComment: isLongComment ? $element.val() : null
				};
			case "singleValueNumber":
			case "multiValueNumber":
				var value = $element.val();

				return {
					type: dataBindingValue,
					value: (value !== "" && Number(value)) || null
				};
			default:
				LoggerInstance.debug(`${dataBinding} is not a supported data binding.`);
				return null;
		}
	},

	validateStartAndEndDates: function(options) {
		options = options || {};
		var existingErrorMessages = options.existingErrorMessages || [];
		var startDate = options.startDate;
		var endDate = options.endDate;
		var dateFormat = options.dateFormat;
		var startDateInvalidMessage = options.startDateInvalidMessage;
		var endDateInvalidMessage = options.endDateInvalidMessage;
		var endDateLessThanStartDateMessage = options.endDateLessThanStartDateMessage;

		//Validating Dates
		var momentStartDate = window.moment(startDate, dateFormat);
		var momentEndDate = window.moment(endDate, dateFormat);
		if (!momentStartDate.isValid()) {
			existingErrorMessages.push(startDateInvalidMessage);
		}

		if (endDate && !momentEndDate.isValid()) {
			existingErrorMessages.push(endDateInvalidMessage);
		}

		if (momentStartDate.isValid() && momentEndDate.isValid() && momentStartDate > momentEndDate) {
			existingErrorMessages.push(endDateLessThanStartDateMessage);
		}

		return existingErrorMessages;
	},

	validateDates: function(options) {
		options = options || {};
		var existingErrorMessages = options.existingErrorMessages || [];
		var date = options.date;
		var dateFormat = options.dateFormat;
		var dateInvalidMessage = options.dateInvalidMessage;

		//Validating Dates
		var momentDate = window.moment(date, dateFormat);
		if (!momentDate.isValid()) {
			existingErrorMessages.push(dateInvalidMessage);
		}

		return existingErrorMessages;
	},

	_validateAmount: function(event, allowDecimals, greaterThanZero, defaultValue, allowNegative) {
		if (!event) {
			return false;
		}
		var value = $(event.currentTarget).val() || "";

		if (value.includes(window.currencyFormat.currencySymbol)) {
			var currencyRegex = new RegExp(ActionsHelper.escapeRegExp(window.currencyFormat.currencySymbol), "g");
			event.currentTarget.value = value.replace(currencyRegex, "");
		}

		//Works as long as the decimal separator is only a single character
		if (!this.isAmountValid(value, allowNegative) || (Number(value) === 0 && greaterThanZero && value !== "") || (!allowDecimals && value.includes("."))) {
			if (defaultValue) {
				event.currentTarget.value = defaultValue;
			} else {
				event.currentTarget.value = event.currentTarget.oldValue;
			}
			return false;
		}

		event.currentTarget.oldValue = value;
		return true;
	},

	_validateDecimal: function (event, greaterThanZero, defaultValue, allowNegative) {
		if (!event) {
			return false;
		}
		var value = $(event.currentTarget).val() || "";

		if (value.includes(window.currencyFormat.currencySymbol)) {
			var currencyRegex = new RegExp(ActionsHelper.escapeRegExp(window.currencyFormat.currencySymbol), "g");
			event.currentTarget.value = value.replace(currencyRegex, "");
		}

		//Works as long as the decimal separator is only a single character
		if (!this.isDecimalValid(value, allowNegative) || (Number(value) === 0 && greaterThanZero && value !== "")) {
			if (defaultValue) {
				event.currentTarget.value = defaultValue;
			} else {
				event.currentTarget.value = event.currentTarget.oldValue;
			}
			return false;
		}

		event.currentTarget.oldValue = value;
		return true;
	}
};
